import { Component, OnDestroy, OnInit } from '@angular/core';
import { CommonApiService } from '../../common-api.service';
import { ConfirmDialogComponent } from '../confirm-dialog/confirm-dialog.component';
import { MatDialog, MatDialogConfig } from "@angular/material/dialog";
import { Router } from '@angular/router';
import { JobOrder } from '../joborder/joborder.interface';
import { SnackbarService } from '../../snackbar.service';

@Component({
    selector: 'app-prod-job-out',
    templateUrl: './prod-job-out.component.html',
    styleUrls: ['./prod-job-out.component.css']
})
export class ProdJobOutComponent implements OnInit, OnDestroy {

    constructor(
        public dialog: MatDialog,
        private router: Router,
        private api: CommonApiService,
        private snackbar: SnackbarService
    ) { }

    result: string = '';
    passwordLength: any;
    public allJobs: any[] = [];
    public filteredJobs = this.allJobs;
    public selectedJob: JobOrder;
    public allReworkProcesses: any[] = [];
    public filteredReworkProcesses = this.allReworkProcesses;
    public selectedReworkProcess: number;
    viewData: boolean;
    public employee_id: number;
    viewReworkProcess :boolean;
    sentToRework :boolean;
    public allComments: any[] = [];
    public comment_description : string;
    public product_name: string;
    public jobHold: boolean = false
    public isNextProcess: boolean = false
    public jobBarcodeValue: string = '';
    public jobScanInProgress: boolean = false;

    ngOnInit(): void {
        this.employee_id = Number(localStorage.getItem('employee_id'));
        if (!this.employee_id) {
            this.snackbar.error('Employee session expired');
            this.router.navigate(['/employeelogin/out']);
        }
        const employee_data = {
            'employee_id': this.employee_id
        }
        this.api.callRoute('joborder','/list/out', employee_data).subscribe(res => {
            this.allJobs = res;
            this.filteredJobs = res;
        })
        this.viewData = false;
    }

    onChangeToggle(elementData:any,event:any){
		
		var value = event.checked; //true or false
		if(value == true){
            this.sentToRework = true;
            this.viewReworkProcess = true;
		} else {
            this.viewReworkProcess = false;
            this.sentToRework = false;

		}
	}

    onReworkProcessKey = (event: Event) => {
        var value = (event.target as HTMLInputElement).value;
        this.filteredReworkProcesses = this.searchReworkProcesses(value);
    }


    searchReworkProcesses(value: string) {
        let filter = value.toLowerCase();
        return this.allReworkProcesses.filter(option =>
            option.process.name.toLowerCase().includes(filter)
        );
    }

    onJobKey = (event: Event) => {
        var value = (event.target as HTMLInputElement).value;
        this.filteredJobs = this.searchJobs(value);
    }

    onJobChange(event:any) {
        this.viewData = true;
        const employee_data = {
            'employee_id': this.employee_id,
            'job_id': this.selectedJob.id
        }
        if (this.selectedJob.next_process) {
            this.isNextProcess = true
        } else {
            this.isNextProcess = false
        }

        this.api.callRoute('joborder','/list/rework', employee_data).subscribe(res => {
            this.allReworkProcesses = res;
            this.filteredReworkProcesses = res;
        })

        var value = event.value.id;
        const data = {
           'job_id': value
        }
        var product_names: any = []
        this.selectedJob.products.forEach((p: any) => {
            product_names.push(p.name)
        });
        this.product_name = product_names.join(", ");
        this.api.callRoute('joborder', '/comments', data).subscribe(
            (data: any) => {
                if (data) {
                    this.allComments = data;
                }
            },
            error => {
                this.snackbar.error(error.message)
            }
        );
    }

    searchJobs(value: string) {
        let filter = value.toLowerCase();
        return this.allJobs.filter(option =>
            option.job_no.toLowerCase().includes(filter)
        );
    }

    confirmDialog(): void {

        if(this.selectedJob == undefined){
            this.snackbar.warning("Please select job.");
            return;
        }

        var outOrRework ="to outward";
        if(this.sentToRework == true){
            var outOrRework ="to rework";
        }
        
        const message = 'Are you sure you want ' +outOrRework+' this job?';
        const dialogConfig = new MatDialogConfig();
        dialogConfig.data = {
            title: "Confirm job out",
            message: message
        }
        const dialogRef = this.dialog.open(ConfirmDialogComponent, dialogConfig);
        dialogRef.afterClosed().subscribe(dialogResult => {
            this.result = dialogResult;
            if (this.result) {
                if (this.sentToRework == true) {
                    this.sendToRework();
                }else{
                    this.createJobOut();
                }
                
                
            }
        });
    }

    saveAndHoldJob(): void {

        if(this.selectedJob == undefined){
            this.snackbar.warning("Please select job.");
            return;
        }
        
        const message = 'Are you sure you want save and hold this job?';
        const dialogConfig = new MatDialogConfig();
        dialogConfig.data = {
            title: "Confirm save and hold job",
            message: message
        }
        const dialogRef = this.dialog.open(ConfirmDialogComponent, dialogConfig);
        dialogRef.afterClosed().subscribe(dialogResult => {
            this.result = dialogResult;
            if (this.result) {
                this.jobHold = true
                this.createJobOut();
                
            }
        });
    }

    keyPress(event: any) {
        this.passwordLength = event.target.value.length;
        if (this.passwordLength >= 0) {

        }
    }

    onJobBarcodeScan(event: KeyboardEvent) {
        if (event.key !== 'Enter') {
            return;
        }
        event.preventDefault();
        const scannedValue = this.jobBarcodeValue.trim();
        if (!scannedValue) {
            return;
        }

        this.jobScanInProgress = true;
        const payload = {
            barcode_value: scannedValue,
            mode: 'out',
            employee_id: this.employee_id
        };

        this.api.callRoute('joborder', '/lookup/barcode', payload).subscribe({
            next: (res: any) => {
                this.jobScanInProgress = false;
                if (res && res.id) {
                    this.selectedJob = res;
                    this.viewData = true;
                    if (this.selectedJob.next_process) {
                        this.isNextProcess = true;
                    } else {
                        this.isNextProcess = false;
                    }
                    var product_names: any = [];
                    this.selectedJob.products.forEach((p: any) => {
                        product_names.push(p.name);
                    });
                    this.product_name = product_names.join(', ');
                    // Load rework processes
                    this.api.callRoute('joborder', '/list/rework', {
                        employee_id: this.employee_id,
                        job_id: res.id
                    }).subscribe(reworkRes => {
                        this.allReworkProcesses = reworkRes;
                        this.filteredReworkProcesses = reworkRes;
                    });
                    // Load comments
                    this.api.callRoute('joborder', '/comments', { job_id: res.id }).subscribe(
                        (data: any) => { if (data) { this.allComments = data; } },
                        error => { this.snackbar.error(error.message); }
                    );
                    this.snackbar.success(`Job ${res.job_no} selected`);
                } else {
                    this.snackbar.error('Job not found or not eligible');
                    this.jobBarcodeValue = '';
                }
            },
            error: (err: any) => {
                this.jobScanInProgress = false;
                this.snackbar.error(err?.error?.message || 'Job not in hand for this employee');
                this.jobBarcodeValue = '';
            }
        });
    }

    createJobOut() {

        const data = {
            'employee_id': this.employee_id,
            'job_id': this.selectedJob.id,
            'comment_description': this.comment_description,
            'process_id': this.selectedJob.current_process.process_id,
            'hold': this.jobHold
        }

        this.api.callRoute('joborder', '/job/out', data).subscribe(
            (data: any) => {
                if (data) {
                    // this.snackbar.info(data.message)
                    if (data.status == 'success') {
                        this.snackbar.success("Successfully processed job outward");
                        this.router.navigate(['/employeelogin/in']);
                    }
                    else if (data.status == 'error') {
                        this.snackbar.info(data.message)
                    }
                }
            },
            error => {
                this.snackbar.error(error.message)
            }

        );
        this.jobHold = false
    }

    sendToRework() {
        if (!this.selectedJob.id) {
            this.snackbar.warning('Please select job to rework');
            return;
        }
        if (!this.selectedReworkProcess) {
            this.snackbar.warning('Please select process to rework');
            return;
        }
        const dialogConfig = new MatDialogConfig();
        dialogConfig.disableClose = true;
        dialogConfig.autoFocus = true;
        dialogConfig.data = {
            title: 'Send Job for Rework',
            message: `Are you sure you want to send job <b>${this.selectedJob.job_no || ''}</b> for rework?`,
            requireRemark: true,
            remarkLabel: 'Rework Reason',
            remarkPlaceholder: 'Describe the issue and what needs to be reworked',
        };
        this.dialog.open(ConfirmDialogComponent, dialogConfig).afterClosed().subscribe((result: any) => {
            if (!result || !result.status) {
                return;
            }
            const data = {
                'employee_id': this.employee_id,
                'job_id': this.selectedJob.id,
                'process_id': this.selectedJob.current_process.process.id,
                'rework_process_id': this.selectedReworkProcess,
                'prod_type': 'rework',
                'rework_reason': result.remark,
            };
            this.api.callRoute('joborder', `/rework/${this.selectedJob.id}`, data).subscribe(
                (data: any) => {
                    if (data) {
                        if (data.success) {
                            this.snackbar.success(data.message);
                            this.router.navigate(['/employeelogin/out']);
                        } else if (!data.success) {
                            this.snackbar.info(data.message);
                        }
                    }
                },
                error => {
                    this.snackbar.error(error?.error?.message || error.message);
                }
            );
        });
    }

    ngOnDestroy(): void {
        localStorage.removeItem('employee_id')
    }
}
